import { useTranslation } from 'react-i18next';
import { DataTable } from '../../../web/src/components/data-table.jsx';
import { Amount } from '../../../web/src/components/display/amount.jsx';
import { translateColumns } from '../../../web/src/locale/translate-columns.js';
import { TRANSACTION_COLUMNS } from './../../../shared-site-web/screens/transaction-table.js';
import { useSiteLang } from '../layout/use-site-lang.js';
import { getMockAccounts } from './mock-data/mock-data.js';
import { getMockAviosTransactions } from './mock-data/mock-transactions.js';
import { inertActions } from './mock-table.jsx';

// Compact column set so the wallet reads like a mobile screenshot.
const MOBILE_KEYS = ['date', 'type', 'amount'];

/**
 * A slice of the flight-mileage account view: the plane-symbol balance and
 * recent activity, trimmed to the columns that fit a mobile-width frame.
 * @returns {JSX.Element}
 */
export function AviosCard() {
	const { t } = useTranslation();
	const lang = useSiteLang();
	const columns = translateColumns(
		TRANSACTION_COLUMNS.filter((c) => MOBILE_KEYS.includes(c.key)),
		t,
	);
	const account = getMockAccounts(lang).find((a) => a.id === 'acc-flight');
	const name = account?.name ?? 'Flight Mileage';
	const balance = account?.balance ?? 0;
	const symbol = account?.currencySymbol ?? '\u2708';
	return (
		<DataTable
			columns={columns}
			rows={getMockAviosTransactions(lang)}
			title={name}
			emptyMessage=""
			extraHeaderActions={
				<span className="mock-balance">
					<Amount value={balance} decimalPlaces={0} symbol={symbol} />
				</span>
			}
			renderActions={inertActions(t)}
		/>
	);
}
